import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 65,
	viewBox: "0 0 64 65",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M32 23.0608C24.5236 23.0608 19.1645 29.4126 17.7215 31.3234C17.4782 31.6455 17.4782 32.076 17.7215 32.3981C19.1645 34.3089 24.5236 40.6608 32 40.6608C39.4764 40.6608 44.8355 34.3089 46.2785 32.3981C46.5217 32.076 46.5217 31.6455 46.2785 31.3234C44.8355 29.4126 39.4764 23.0608 32 23.0608Z",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 32,
		cy: 31.8608,
		r: 3.4,
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgView;
